module.exports = __webpack_public_path__ + "img/nc.nc52e1a83.svg";